module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/a690978a344ca5b92167477bf5bb2027.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Emerald/Emerald5.svg
// module id = ixbo
// module chunks = 1